import { createApi } from "@reduxjs/toolkit/query/react";
import { extendedBaseQuery } from "../basequery";

export const googleAnalyticsSectionApi = createApi({
  reducerPath: "googleAnalyticsSectionApi",
  baseQuery: extendedBaseQuery,
  tagTypes: ["GoogleAnalyticsSection"],
  endpoints: (builder) => ({
    getGoogleAnalyticsSections: builder.query({
      query: (params) => {
        const query = {};
        if (params?.skip) query.skip = params.skip;
        if (params?.limit) query.limit = params.limit;
        if (params?.search) query.search = params.search;
        if (params?.filter) query.filter = params.filter;
        if (params?.sortBy) query.sortBy = params.sortBy;
        if (params?.orderBy) query.orderBy = params.orderBy;

        return {
          url: `google-analytics-section?${new URLSearchParams(query).toString()}`,
          method: "GET",
        };
      },
      providesTags: ["GoogleAnalyticsSection"],
    }),
    getGoogleAnalyticsSectionById: builder.query({
      query: (id) => ({
        url: `google-analytics-section/${id}`,
        method: "GET",
      }),
      providesTags: ["GoogleAnalyticsSection"],
    }),
    createGoogleAnalyticsSection: builder.mutation({
      query: (body) => ({
        url: "google-analytics-section/create",
        method: "POST",
        body,
      }),
      invalidatesTags: ["GoogleAnalyticsSection"],
    }),
    updateGoogleAnalyticsSection: builder.mutation({
      query: (body) => ({
        url: `google-analytics-section/${body.id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["GoogleAnalyticsSection"],
    }),
  }),
});

export const {
  useGetGoogleAnalyticsSectionsQuery,
  useGetGoogleAnalyticsSectionByIdQuery,
  useCreateGoogleAnalyticsSectionMutation,
  useUpdateGoogleAnalyticsSectionMutation,
} = googleAnalyticsSectionApi;

